import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$3 } from './cosmos-icon-checkmark2.js';
import { d as defineCustomElement$2 } from './cosmos-text2.js';
import { b as bem } from './bem.js';

const cosmosOptionCss = ":host{display:block;margin:0 !important;max-width:100%;position:relative;width:100%}:host(:focus-visible){outline:none}:host(:focus-visible)::before{content:\"\";border-radius:calc(4px * 1.5);bottom:calc((4px + -4px) * -1);-webkit-box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;left:calc((4px + -4px) * -1);position:absolute;right:calc((4px + -4px) * -1);top:calc((4px + -4px) * -1)}.cosmos-option{-ms-flex-align:center;align-items:center;border-radius:4px;-webkit-box-sizing:border-box;box-sizing:border-box;cursor:default;display:-ms-flexbox;display:flex;gap:var(--cosmos-option-gap, 8px);margin:0;max-width:100%;padding:6px 8px;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%;--cosmos-text-color:var(--cosmos-option-color);--cosmos-text-font-family:var(--cosmos-option-font-family);--cosmos-text-font-size:var(--cosmos-option-font-size);--cosmos-text-font-style:var(--cosmos-option-font-style);--cosmos-text-font-weight:var(--cosmos-option-font-weight);--cosmos-text-letter-spacing:var(--cosmos-option-letter-spacing);--cosmos-text-line-height:var(--cosmos-option-line-height);--cosmos-text-text-transform:var(--cosmos-option-text-transform)}.cosmos-option__icon{--cosmos-icon-color:#000F1E;-ms-flex:0 0 auto;flex:0 0 auto;height:18px;width:18px}.cosmos-option__label{overflow:hidden}.cosmos-option--disabled{--cosmos-text-color:rgba(0, 15, 30, 0.45)}.cosmos-option--disabled .cosmos-option__icon{--cosmos-icon-color:rgba(0, 15, 30, 0.45)}.cosmos-option:hover:not(.cosmos-option--disabled){background:rgba(0, 15, 30, 0.1)}.cosmos-option--appearance-light .cosmos-option__icon{--cosmos-icon-color:#FFFFFF}.cosmos-option--appearance-light.cosmos-option--disabled{--cosmos-text-color:rgba(255, 255, 255, 0.45)}.cosmos-option--appearance-light.cosmos-option--disabled .cosmos-option__icon{--cosmos-icon-color:rgba(255, 255, 255, 0.45)}.cosmos-option--appearance-light:hover:not(.cosmos-option--disabled){background:rgba(255, 255, 255, 0.1)}.cosmos-option ::slotted([slot=prefix]){-ms-flex:0 0 auto;flex:0 0 auto}";
const CosmosOptionStyle0 = cosmosOptionCss;

const generateClassNames = bem('cosmos-option');
const CosmosOption$1 = /*@__PURE__*/ proxyCustomElement(class CosmosOption extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.optionselectEvent = createEvent(this, "optionselect", 7);
        this.appearance = 'dark';
        this.disabled = false;
        this.selected = false;
        this.value = '';
    }
    mouseDownHandler() {
        if (this.disabled) {
            return;
        }
        this.optionselectEvent.emit({ value: this.value });
    }
    handleSelectedChange(newValue, currentValue) {
        if (newValue && newValue !== currentValue) {
            this.optionselectEvent.emit({ value: this.value });
        }
    }
    render() {
        var _a;
        return (h(Host, { role: "option", "aria-label": (_a = this.element.textContent) === null || _a === void 0 ? void 0 : _a.trim(), "aria-selected": this.selected.toString(), "aria-disabled": this.disabled ? 'true' : undefined }, h("div", { class: generateClassNames({
                disabled: this.disabled,
                appearance: this.appearance,
            }), part: "base" }, (this.selected && h("cosmos-icon-checkmark", { class: generateClassNames('icon') })) || (h("div", { class: generateClassNames('icon') })), h("slot", { "aria-hidden": "true", name: "prefix" }), h("cosmos-text", { appearance: this.appearance, exportparts: "base: label", class: generateClassNames('label'), size: "small", clamp: 1 }, h("span", null, h("slot", null))))));
    }
    get element() { return this; }
    static get watchers() { return {
        "selected": ["handleSelectedChange"]
    }; }
    static get style() { return CosmosOptionStyle0; }
}, [1, "cosmos-option", {
        "appearance": [513],
        "disabled": [516],
        "selected": [516],
        "value": [513]
    }, [[1, "mousedown", "mouseDownHandler"]], {
        "selected": ["handleSelectedChange"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-option", "cosmos-icon-checkmark", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-option":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosOption$1);
            }
            break;
        case "cosmos-icon-checkmark":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosOption = CosmosOption$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosOption, defineCustomElement };
